module["exports"] = [
  "01########",
  "02########",
  "03########",
  "04########",
  "05########",
  "06########",
  "07########",
  "+33 1########",
  "+33 2########",
  "+33 3########",
  "+33 4########",
  "+33 5########",
  "+33 6########",
  "+33 7########"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr/phone_number/formats.js
 ** module id = 703
 ** module chunks = 0
 **/